// import { expose } from "threads/worker";

function compareSubParams(modifiedParam, originalParam) {
  // console.log("modifiedParam", modifiedParam);
  // console.log("originalParam", originalParam);
  var result = [];

  for (const prop in modifiedParam) {
    if (modifiedParam[prop].param_value != originalParam[prop].param_value) {
      let newSubParam = new Object();
      newSubParam.param_id = modifiedParam[prop].param_id;
      newSubParam.param_name = modifiedParam[prop].param_name;
      newSubParam.param_value = modifiedParam[prop].param_value;
      newSubParam.original_value = originalParam[prop].param_value;
      result.push(newSubParam);
    }
  }
  return result;
}

// expose({
//   compareParameters(modifiedArray, originalArray) {
//     var result = {};
//     for (const sectionIndex in modifiedArray) {
//       for (const groupIndex in modifiedArray[sectionIndex].groups) {
//         for (const paramIndex in modifiedArray[sectionIndex].groups[groupIndex]
//           .group_params) {
//           // console.log("#", JSON.stringify(modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex]));

//           if (
//             modifiedArray[sectionIndex].groups[groupIndex].group_params[
//               paramIndex
//             ].param_type != "enum"
//           ) {
//             let modified_value =
//               modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                 paramIndex
//               ].param_value;
//             let original_value =
//               originalArray[sectionIndex].groups[groupIndex].group_params[
//                 paramIndex
//               ].param_value;

//             // nome do grupo
//             var groupName =
//               modifiedArray[sectionIndex].groups[groupIndex].group_name;

//             var alreadyPassed = false;

//             if (modified_value != original_value) {
//               let newParam = new Object();

//               // nome da secção
//               newParam.section_name = modifiedArray[sectionIndex].section_name;

//               // nome, id e valor do parâmetro
//               newParam.param_id =
//                 modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_id;
//               newParam.param_name =
//                 modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_name;
//               newParam.param_value =
//                 modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_value;

//               // valor original
//               newParam.original_value =
//                 originalArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_value;

//               // Trabalhar com sub-parâmetros
//               if (
//                 modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_subparams
//               ) {
//                 alreadyPassed = true;
//                 var modifiedSubParams =
//                   modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                     paramIndex
//                   ].param_subparams;
//                 var originalSubParams =
//                   originalArray[sectionIndex].groups[groupIndex].group_params[
//                     paramIndex
//                   ].param_subparams;
//                 if (
//                   modifiedSubParams.length > 0 &&
//                   originalSubParams.length > 0
//                 ) {
//                   // Compara os sub-parâmetros
//                   let subParams = compareSubParams(
//                     modifiedSubParams,
//                     originalSubParams
//                   );
//                   // console.log("subParams", JSON.stringify(subParams));
//                   if (subParams.length > 0) {
//                     if (!newParam.param_subparams)
//                       newParam.param_subparams = [];
//                     subParams.forEach((item) =>
//                       newParam.param_subparams.push(item)
//                     );
//                   }
//                 }
//               }

//               if (!result[newParam.section_name])
//                 result[newParam.section_name] = {};
//               if (!result[newParam.section_name][groupName])
//                 result[newParam.section_name][groupName] = [];

//               // result[newParam.section_name].push(newParam);
//               result[newParam.section_name][groupName].push(newParam);
//             } //end (modified_value != original_value)

//             // Trabalhar com sub-parâmetros
//             // Quando você altera um sub-parâmetro sem alterar o parâmetro principal (primeiro nível).
//             if (
//               modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                 paramIndex
//               ].param_subparams &&
//               !alreadyPassed
//             ) {
//               var modifiedSubParams =
//                 modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_subparams;
//               var originalSubParams =
//                 originalArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_subparams;
//               if (
//                 modifiedSubParams.length > 0 &&
//                 originalSubParams.length > 0
//               ) {
//                 // Compara os sub-parâmetros
//                 let subParams = compareSubParams(
//                   modifiedSubParams,
//                   originalSubParams
//                 );
//                 if (subParams.length > 0) {
//                   let newSubParam = new Object();

//                   // nome da secção
//                   newSubParam.section_name =
//                     modifiedArray[sectionIndex].section_name;

//                   // nome, id e valor do parâmetro
//                   newSubParam.param_id =
//                     modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                       paramIndex
//                     ].param_id;
//                   newSubParam.param_name =
//                     modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                       paramIndex
//                     ].param_name;
//                   newSubParam.param_value =
//                     modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                       paramIndex
//                     ].param_value;

//                   // valor original
//                   newSubParam.original_value =
//                     originalArray[sectionIndex].groups[groupIndex].group_params[
//                       paramIndex
//                     ].param_value;

//                   if (!result[newSubParam.section_name])
//                     result[newSubParam.section_name] = {};
//                   if (!result[newSubParam.section_name][groupName])
//                     result[newSubParam.section_name][groupName] = [];

//                   subParams.forEach((item) => {
//                     if (!newSubParam.param_subparams)
//                       newSubParam.param_subparams = [];
//                     newSubParam.param_subparams.push(item);
//                   });

//                   result[newSubParam.section_name][groupName].push(newSubParam);
//                 }
//               }
//             } //end (modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams && !alreadyPassed)
//           } //end modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_type != "enum"
//           else {
//             // +---------------------------------------------------+
//             // | param_type == "enum"                              |
//             // +---------------------------------------------------+
//             // ---------------------------------------------------------------------------------
//             // ---------------------------------------------------------------------------------
//             // ---------------------------------------------------------------------------------
//             // console.log("%c# Deu bom #", "font-size: 30px; font-weight: bold; color: chartreuse;");
//             // console.log(modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex]);

//             let modified_value =
//               modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                 paramIndex
//               ].param_value_id;
//             let original_value =
//               originalArray[sectionIndex].groups[groupIndex].group_params[
//                 paramIndex
//               ].param_value_id;

//             // nome do grupo
//             var groupName =
//               modifiedArray[sectionIndex].groups[groupIndex].group_name;

//             // console.log("modified_value:", modified_value);
//             // console.log("original_value:", original_value);

//             var alreadyPassed = false;

//             if (modified_value != original_value) {
//               // console.log("%c# entrou #", "font-size: 20px; font-weight: bold; color: aqua;");
//               // console.log("    group_name:", groupName);
//               // console.log("modified_value:", modified_value);
//               // console.log("original_value:", original_value);

//               let newParam = new Object();

//               // // nome da secção
//               newParam.section_name = modifiedArray[sectionIndex].section_name;

//               // nome, id e valor do parâmetro
//               newParam.param_id =
//                 modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_id;
//               newParam.param_name =
//                 modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_name;
//               newParam.param_value =
//                 modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_value_id;

//               // // valor original
//               newParam.original_value =
//                 originalArray[sectionIndex].groups[groupIndex].group_params[
//                   paramIndex
//                 ].param_value_id;

//               // console.log("Checar sub-parâmetros...");
//               // console.log(JSON.stringify(modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex]));

//               // Trabalhar com sub-parâmetros
//               // if (modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams) {
//               //   console.log("%c# has sub-params #", "font-size: 30px; font-weight: bold; color: yellow;");
//               //   alreadyPassed = true;
//               //   var modifiedSubParams = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
//               //   var originalSubParams = originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
//               //   if (modifiedSubParams.length > 0 && originalSubParams.length > 0) {
//               //     // Compara os sub-parâmetros
//               //     let subParams = compareSubParams(modifiedSubParams, originalSubParams);
//               //     // console.log("subParams", JSON.stringify(subParams));
//               //     if (subParams.length > 0) {
//               //       if (!newParam.param_subparams) newParam.param_subparams = [];
//               //       subParams.forEach(item => newParam.param_subparams.push(item));
//               //     }
//               //   }
//               // }

//               // if (!result[newParam.section_name]) result[newParam.section_name] = {};
//               // if (!result[newParam.section_name][groupName]) result[newParam.section_name][groupName] = [];

//               // // result[newParam.section_name].push(newParam);
//               // result[newParam.section_name][groupName].push(newParam);
//             } //end (modified_value != original_value)

//             // Trabalhar com sub-parâmetros
//             // Quando você altera um sub-parâmetro sem alterar o parâmetro principal (primeiro nível).
//             if (
//               modifiedArray[sectionIndex].groups[groupIndex].group_params[
//                 paramIndex
//               ].param_subparams &&
//               !alreadyPassed
//             ) {
//               // console.log("%c# Step 4 #", "font-size: 30px; font-weight: bold; color: orangered;");
//               // var modifiedSubParams = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
//               // var originalSubParams = originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
//               // if (modifiedSubParams.length > 0 && originalSubParams.length > 0) {
//               //   // Compara os sub-parâmetros
//               //   let subParams = compareSubParams(modifiedSubParams, originalSubParams);
//               //   if (subParams.length > 0) {
//               //     let newSubParam = new Object();
//               //     // nome da secção
//               //     newSubParam.section_name = modifiedArray[sectionIndex].section_name;
//               //     // nome, id e valor do parâmetro
//               //     newSubParam.param_id = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_id;
//               //     newSubParam.param_name = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_name;
//               //     newSubParam.param_value = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value;
//               //     // valor original
//               //     newSubParam.original_value = originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value;
//               //     if (!result[newSubParam.section_name]) result[newSubParam.section_name] = {};
//               //     if (!result[newSubParam.section_name][groupName]) result[newSubParam.section_name][groupName] = [];
//               //     subParams.forEach(item => {
//               //       if (!newSubParam.param_subparams) newSubParam.param_subparams = [];
//               //       newSubParam.param_subparams.push(item);
//               //     });
//               //     result[newSubParam.section_name][groupName].push(newSubParam);
//               //   }
//               // }
//             } //end (modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams && !alreadyPassed)
//             // ---------------------------------------------------------------------------------
//             // ---------------------------------------------------------------------------------
//             // ---------------------------------------------------------------------------------
//           }
//           // end else
//         }
//       } // for (const groupIndex in modifiedArray[sectionIndex].groups)
//     } // for (const sectionIndex in modifiedArray)
//     return result;
//   },
// });

export function compareParameters(modifiedArray, originalArray) {
  var result = {};
  for (const sectionIndex in modifiedArray) {
    for (const groupIndex in modifiedArray[sectionIndex].groups) {
      for (const paramIndex in modifiedArray[sectionIndex].groups[groupIndex].group_params) {
        // console.log("#", JSON.stringify(modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex]));

        if (modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_type != "enum") {
          let modified_value = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value;
          let original_value = originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value;

          // nome do grupo
          var groupName = modifiedArray[sectionIndex].groups[groupIndex].group_name;

          var alreadyPassed = false;

          if (modified_value != original_value) {
            let newParam = new Object();

            // nome da secção
            newParam.section_name = modifiedArray[sectionIndex].section_name;

            // nome, id e valor do parâmetro
            newParam.param_id = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_id;
            newParam.param_name = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_name;
            newParam.param_value = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value;

            // valor original
            newParam.original_value =
              originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value;

            // Trabalhar com sub-parâmetros
            if (modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams) {
              alreadyPassed = true;
              var modifiedSubParams =
                modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
              var originalSubParams =
                originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
              if (modifiedSubParams.length > 0 && originalSubParams.length > 0) {
                // Compara os sub-parâmetros
                let subParams = compareSubParams(modifiedSubParams, originalSubParams);
                // console.log("subParams", JSON.stringify(subParams));
                if (subParams.length > 0) {
                  if (!newParam.param_subparams) newParam.param_subparams = [];
                  subParams.forEach((item) => newParam.param_subparams.push(item));
                }
              }
            }

            if (!result[newParam.section_name]) result[newParam.section_name] = {};
            if (!result[newParam.section_name][groupName]) result[newParam.section_name][groupName] = [];

            // result[newParam.section_name].push(newParam);
            result[newParam.section_name][groupName].push(newParam);
          } //end (modified_value != original_value)

          // Trabalhar com sub-parâmetros
          // Quando você altera um sub-parâmetro sem alterar o parâmetro principal (primeiro nível).
          if (
            modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams &&
            !alreadyPassed
          ) {
            var modifiedSubParams =
              modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
            var originalSubParams =
              originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
            if (modifiedSubParams.length > 0 && originalSubParams.length > 0) {
              // Compara os sub-parâmetros
              let subParams = compareSubParams(modifiedSubParams, originalSubParams);
              if (subParams.length > 0) {
                let newSubParam = new Object();

                // nome da secção
                newSubParam.section_name = modifiedArray[sectionIndex].section_name;

                // nome, id e valor do parâmetro
                newSubParam.param_id = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_id;
                newSubParam.param_name =
                  modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_name;
                newSubParam.param_value =
                  modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value;

                // valor original
                newSubParam.original_value =
                  originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value;

                if (!result[newSubParam.section_name]) result[newSubParam.section_name] = {};
                if (!result[newSubParam.section_name][groupName]) result[newSubParam.section_name][groupName] = [];

                subParams.forEach((item) => {
                  if (!newSubParam.param_subparams) newSubParam.param_subparams = [];
                  newSubParam.param_subparams.push(item);
                });

                result[newSubParam.section_name][groupName].push(newSubParam);
              }
            }
          } //end (modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams && !alreadyPassed)
        } //end modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_type != "enum"
        else {
          // +---------------------------------------------------+
          // | param_type == "enum"                              |
          // +---------------------------------------------------+
          // ---------------------------------------------------------------------------------
          // ---------------------------------------------------------------------------------
          // ---------------------------------------------------------------------------------
          // console.log("%c# Deu bom #", "font-size: 30px; font-weight: bold; color: chartreuse;");
          // console.log(modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex]);

          let modified_value = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value_id;
          let original_value = originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value_id;

          // nome do grupo
          var groupName = modifiedArray[sectionIndex].groups[groupIndex].group_name;

          // console.log("modified_value:", modified_value);
          // console.log("original_value:", original_value);

          var alreadyPassed = false;

          if (modified_value != original_value) {
            // console.log("%c# entrou #", "font-size: 20px; font-weight: bold; color: aqua;");
            // console.log("    group_name:", groupName);
            // console.log("modified_value:", modified_value);
            // console.log("original_value:", original_value);

            let newParam = new Object();

            // // nome da secção
            newParam.section_name = modifiedArray[sectionIndex].section_name;

            // nome, id e valor do parâmetro
            newParam.param_id = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_id;
            newParam.param_name = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_name;
            newParam.param_value =
              modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value_id;

            // // valor original
            newParam.original_value =
              originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value_id;

            // console.log("Checar sub-parâmetros...");
            // console.log(JSON.stringify(modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex]));

            // Trabalhar com sub-parâmetros
            // if (modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams) {
            //   console.log("%c# has sub-params #", "font-size: 30px; font-weight: bold; color: yellow;");
            //   alreadyPassed = true;
            //   var modifiedSubParams = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
            //   var originalSubParams = originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
            //   if (modifiedSubParams.length > 0 && originalSubParams.length > 0) {
            //     // Compara os sub-parâmetros
            //     let subParams = compareSubParams(modifiedSubParams, originalSubParams);
            //     // console.log("subParams", JSON.stringify(subParams));
            //     if (subParams.length > 0) {
            //       if (!newParam.param_subparams) newParam.param_subparams = [];
            //       subParams.forEach(item => newParam.param_subparams.push(item));
            //     }
            //   }
            // }

            // if (!result[newParam.section_name]) result[newParam.section_name] = {};
            // if (!result[newParam.section_name][groupName]) result[newParam.section_name][groupName] = [];

            // // result[newParam.section_name].push(newParam);
            // result[newParam.section_name][groupName].push(newParam);
          } //end (modified_value != original_value)

          // Trabalhar com sub-parâmetros
          // Quando você altera um sub-parâmetro sem alterar o parâmetro principal (primeiro nível).
          if (
            modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams &&
            !alreadyPassed
          ) {
            // console.log("%c# Step 4 #", "font-size: 30px; font-weight: bold; color: orangered;");
            // var modifiedSubParams = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
            // var originalSubParams = originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams;
            // if (modifiedSubParams.length > 0 && originalSubParams.length > 0) {
            //   // Compara os sub-parâmetros
            //   let subParams = compareSubParams(modifiedSubParams, originalSubParams);
            //   if (subParams.length > 0) {
            //     let newSubParam = new Object();
            //     // nome da secção
            //     newSubParam.section_name = modifiedArray[sectionIndex].section_name;
            //     // nome, id e valor do parâmetro
            //     newSubParam.param_id = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_id;
            //     newSubParam.param_name = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_name;
            //     newSubParam.param_value = modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value;
            //     // valor original
            //     newSubParam.original_value = originalArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_value;
            //     if (!result[newSubParam.section_name]) result[newSubParam.section_name] = {};
            //     if (!result[newSubParam.section_name][groupName]) result[newSubParam.section_name][groupName] = [];
            //     subParams.forEach(item => {
            //       if (!newSubParam.param_subparams) newSubParam.param_subparams = [];
            //       newSubParam.param_subparams.push(item);
            //     });
            //     result[newSubParam.section_name][groupName].push(newSubParam);
            //   }
            // }
          } //end (modifiedArray[sectionIndex].groups[groupIndex].group_params[paramIndex].param_subparams && !alreadyPassed)
          // ---------------------------------------------------------------------------------
          // ---------------------------------------------------------------------------------
          // ---------------------------------------------------------------------------------
        }
        // end else
      }
    } // for (const groupIndex in modifiedArray[sectionIndex].groups)
  } // for (const sectionIndex in modifiedArray)
  return result;
}
